
import { defineComponent, onMounted, reactive } from 'vue'

// @ui-kit
import NewSelect from '@/ui-kit/NewSelect/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'
import NewInput from '@/ui-kit/NewInput/index.vue'

// @types
import { UserT } from '@/core/types/users.types'

// @realisations
import { users } from '@/core/realisations/users.realisation'

export default defineComponent({
    components: {
        NewSelect,
        NewButton,
        NewInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'reset'],
    setup(props, { emit }) {
        const state = reactive({
            operatorEmail: null as string | null,
            periodFrom: null as string | null,
            periodTo: null as string | null,
        })

        const data_state = reactive({
            operators: {
                is_loading: false,
                is_failed: false,
                list: [] as UserT[],
                pagination: {
                    current_page: 1,
                    total_pages: 1,
                    limit: null as number | null,
                    total_items: null as number | null,
                },
            },
        })

        //

        const loadOperators = async (page: number, name?: string) => {
            data_state.operators.pagination.current_page = page

            try {
                data_state.operators.is_loading = true

                const params = {
                    page,
                    name,
                    roleId: 15,
                    status: true,
                }
                const operators = await users.getList(params)

                data_state.operators.list = operators.data

                data_state.operators.pagination.total_pages = operators.meta.last_page

                data_state.operators.is_failed = false
            } catch (error) {
                data_state.operators.is_failed = true
                console.error(error)
            } finally {
                data_state.operators.is_loading = false
            }
        }

        const loadMoreOperators = async (page: number) => {
            if (page > data_state.operators.pagination.total_pages) return
            data_state.operators.pagination.current_page = page

            try {
                data_state.operators.is_loading = true

                const params = {
                    page,
                    roleId: 15,
                    status: true,
                }
                const operators = await users.getList(params)
                data_state.operators.list = data_state.operators.list.concat(operators.data)

                data_state.operators.pagination.total_pages = operators.meta.last_page

                data_state.operators.is_failed = false
            } catch (error) {
                data_state.operators.is_failed = true
                console.error(error)
            } finally {
                data_state.operators.is_loading = false
            }
        }

        const searchOperators = async (search_query: string) => {
            loadOperators(1, search_query)
        }

        const unshiftFindedOperator = async (operator: UserT) => {
            await loadOperators(data_state.operators.pagination.current_page)
            data_state.operators.list.unshift(operator)
        }

        //

        const onFiltersChanged = () => {
            if (props.disabled || props.loading) return
            emit('submit', { ...state })
        }

        const onFiltersReset = () => {
            state.operatorEmail = null
            state.periodFrom = null
            state.periodTo = null

            emit('reset')
        }

        //

        onMounted(() => {
            loadOperators(1)
        })

        //

        return {
            state,
            data_state,
            //
            onFiltersChanged,
            onFiltersReset,
            //
            loadOperators,
            loadMoreOperators,
            searchOperators,
            unshiftFindedOperator,
        }
    },
})
